import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { HashRouter } from 'react-router-dom'
import AuthProvider from './context/UserContext'

ReactDOM.render(
    <HashRouter basename="/">
        <AuthProvider>
            <App />
        </AuthProvider>
    </HashRouter>        
    ,
    document.getElementById('root')
)